import React from 'react';
import { Typography, Box, Checkbox } from '@mui/material';
import Rating from './Rating';
import { useTranslation } from 'react-i18next';
const Question = ({ type,question, subtext, index, options, handleRatingChange, rating,handleTextCombo }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(rating);
  const handleChange = (index,e) => {
    setChecked(e.target.checked);
    handleRatingChange(index, {id:e.target.checked && 1,description:''+e.target.checked+''});
  };
  return (
    <Box mb={3}>
    {type === 'check' ?
    <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
      <Typography variant="h6" gutterBottom>{(index+1)+" - "+t(question)}</Typography>
      <Checkbox label={t(question)} checked={checked} onChange={(e) => handleChange(index, e)} inputProps={{ 'aria-label': 'controlled' }}/> 
    </Box>:
      <>
      <Typography variant="h6" gutterBottom>{(index+1)+" - "+t(question)}</Typography>
      <Typography variant="subtitle2" gutterBottom fontStyle="italic">{t(subtext)}</Typography>
      <Box sx={{width:"100%"}}>
        <Rating index={index} type={type} options={options} handleRatingChange={handleRatingChange} rating={rating} handleTextCombo={handleTextCombo}/>
      </Box>
      </>
  }
  </Box>

  );
};

export default Question;